// @ts-ignore
import React from 'react';
import { Link } from "react-router-dom";
import blogs from "./Blog/blogs";


// @ts-ignore
import blog1 from "@/assets/images/HNIs-Blog3.jpg";
// @ts-ignore
import blog2 from "@/assets/images/Psychology-Blog1.jpg";
// @ts-ignore
import blog3 from "@/assets/images/Psychology-Blog2.jpg";

const blogg = [
  {
    id: 1,
    image: blog1,
    title: "The Asset Classes Most HNIs Ignore",
    description: "Ask most high-net-worth individuals to describe their portfolio, and you'll hear a familiar list: equity mutual funds...",
    slug: "assetclasses",

  },
  {
    id: 2,
    image: blog2,
    title: "The Psychology of Wealth",
    description: "Most investors believe wealth is built through superior market knowledge, timely investment decisions...",
    slug: "thepsychologywealth",
  },
  {
    id: 3,
    image: blog3,
    title: "The Current State of Wealth Management in India",
    description: "India's wealth management industry is in the middle of a significant transformation...",
    slug: "thecurrentstate",
  }
];

function Blog() {

  return (
    <section id="blog" className="py-12 sm:py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4 sm:mb-6">
            Latest Blogs
          </h2>

        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {blogg.slice(0, 3).map((blog) => (
            <div key={blog.id} className="bg-card border border-border rounded-lg p-8 hover:border-accent/50 hover:shadow-lg transition-all duration-300">
              <div >
                <a href="#">
                  <img className="rounded-t-base w-full"
                    src={blog.image}
                    alt={blog.title}
                  />
                </a>
                <div className="p-2 text-center">
                  <h3 className="font-heading font-semibold text-xl text-left text-foreground mb-4 h-[3rem] ">
                    {blog.title}
                  </h3>
                  <p className="mt-3 mb-6 text-muted-foreground text-left leading-relaxed">{blog.description}</p>

                  <Link to={`blog/${blog.slug}`}>

                    <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 shadow h-10 rounded-md bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 text-base w-full sm:w-auto">Know More</button>
                  </Link>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section >
  );
}

export default Blog;